import React from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'solito/router';
import LoginModal from 'app/components/utility/modals/LoginModal';
import loadable from '@loadable/component';
const PaymentModal = loadable(() => import('app/components/utility/modals/PaymentModal'));
const withAuthModal = WrappedComponent => {
  const AuthModalWrapper = props => {
    const profile = useSelector(state => state.profile);
    const isAuthenticated = !!profile?.id;
    const router = useRouter();
    const isProfilePage = router.pathname === '/profile'; // Adjust this path as needed

    const showLoginModal = !isAuthenticated || isProfilePage;
    const showPaymentModal = isAuthenticated;
    return /*#__PURE__*/React.createElement(React.Fragment, null, showLoginModal && /*#__PURE__*/React.createElement(LoginModal, null), showPaymentModal && /*#__PURE__*/React.createElement(PaymentModal, null), /*#__PURE__*/React.createElement(WrappedComponent, props));
  };
  return AuthModalWrapper;
};
export default withAuthModal;